module.exports = __webpack_public_path__ + "static/media/cubes.09176be1.svg";